import { Culture } from '../../types';

export const yavapai: Culture = {
  name: 'Yavapai',
  languageFamily: 'Yuman-Cochimí',
  terms: [
    {
      word: 'Hakame',
      phonetic: 'hah-kah-meh',
      description: 'Yavapai word meaning "spring" or "water source."'
    },
    {
      word: 'Hakiva',
      phonetic: 'hah-kee-vah',
      description: 'Yavapai word for "mountain."'
    },
    {
      word: 'Kwevkapaya',
      phonetic: 'kwehv-kah-pah-yah',
      description: 'Yavapai name for themselves, meaning "The People of the Forest."'
    },
    {
      word: 'Matak',
      phonetic: 'mah-tahk',
      description: 'Word for "earth" in Yavapai.'
    },
    {
      word: 'Matavi',
      phonetic: 'mah-tah-vee',
      description: 'Yavapai word for "sky."'
    },
    {
      word: 'Nyavkay',
      phonetic: 'nyahv-kay',
      description: 'Yavapai word for "mountain."'
    },
    {
      word: 'Wayi',
      phonetic: 'wah-yee',
      description: 'Yavapai word for "fire."'
    },
    {
      word: 'Wipuk',
      phonetic: 'wee-pook',
      description: 'Word meaning "pine" or "forest" in Yavapai.'
    },
    {
      word: 'Yavapai',
      phonetic: 'yah-vah-pie',
      description: 'Their name for themselves, meaning "People of the Sun."'
    },
    {
      word: 'Yawa',
      phonetic: 'yah-wah',
      description: 'Yavapai word meaning "speak" or "language."'
    }
  ]
};